<template>
  <a v-if="!$vlastMode && $userIsClient" :href="link" target="_blank" class="helpLink" aria-label="help" @click="trackHelpClick">
    <i class="fa fa-question"></i>
  </a>
</template>

<script>
import {mapState} from 'vuex'
import { OpportunityTracker } from 'mixins/analytics'

export default {
  mixins: [OpportunityTracker],
  props: {
    anchor: {
      type: String,
      default: null
    }
  },

  methods: {
    trackHelpClick () {
      this.trackEvent(this.analytics.V2.MoreInfoIconClickEvent, { pageName: this.$route.name })
    }
  },

  computed: {
    ...mapState('app', ['helpLink']),

    link () {
      return this.anchor ? `${this.helpLink}#${this.anchor}` : this.helpLink
    }
  }
}
</script>

<style lang="scss" scoped >

@import "src/assets/sass/colours";

.helpLink {
  background-color: $grey-medium;
  color: $grey-light;
  display: inline-block;
  vertical-align: baseline;
  width: 1.5rem;
  height: 1.5rem;
  text-align: center;
  line-height: 1.5rem;
  border-radius: 100%;
  font-size: 1.15rem;
  overflow: hidden;

  &:hover {
    background-color: var(--brand-primary);
  }
}

</style>
